import { useQuery } from 'react-query'

import { IFilter } from 'src/components/filter/types/filter.types'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'
import { challengesService } from 'src/services/challenges.service'

export const initialChallengesFilter = { query: '' }

export const useGetChallenges = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.CHALLENGES, filter ?? initialChallengesFilter],
    () =>
      challengesService.getChallenges(removeDefaultParams(filter ?? {}, initialChallengesFilter)),
    { keepPreviousData: true },
  )
}
